import React, { useState } from 'react'
import { SubscriptionDeactivation } from '../SubscriptionDeactivation'
import { ChangeContractDialog } from './common/ChangeContractDialog'
import { Contract } from '../../../../../types/contract'
import { ContractPaymentInfoBanner } from '../ContractPaymentBanner'
import { translations } from '../../../../../utils/translations/translations-manager'
export function SubscriptionDeactivationDialog({
  subscription,
  visible,
  close,
  success,
}: {
  subscription: Contract
  visible: boolean
  close: () => void
  success: () => void
}): JSX.Element {
  if (!subscription.charityId || !subscription._id) throw new Error('Charity ID and Subscription ID must be defined')
  // Completed used to handle right closing the dialog after the change was successful as success
  const [completed, setCompleted] = useState(false)

  return (
    <ChangeContractDialog
      visible={visible}
      close={completed ? success : close}
      title={completed ? translations.texts.donation_updated.toString() : translations.texts.deactive_subscription.toString()}
    >
      {!completed && <ContractPaymentInfoBanner contract={subscription} className="mb-8" />}
      <SubscriptionDeactivation
        charityId={subscription.charityId}
        contractId={subscription._id}
        success={success}
        complete={() => setCompleted(true)}
        cancel={close}
      />
    </ChangeContractDialog>
  )
}
